
import Vue from 'vue'
import { v4 as uuid } from 'uuid'
import { mapGetters } from 'vuex'
import { VesselBay } from "@/core/services/store/vesselMonitoring.types"
import VesselMonitoringBay from './VesselMonitoringBay.vue'


export default Vue.extend({
  components: {
    VesselMonitoringBay
  },
  props: {
    vesselBay: {
      type: Object as () => VesselBay,
      default: () => ({
        vesselBayType: 1,
        sequense: 1,
        vesselProfileHatchId: 1,
        bay: '001(002)',
        onDeck: {
          cols: 4,
          rows: 4,
          cells: [{
            containerNo: 1,
            containerCycleId: 1,
            lineOperator: 1,
            isoCode: 1,
            portOfDischarge: "sdf",
            color: "#ff00ff",
            existed: true,
            isReefer: true,
            is40Foot: false,
            is45Foot: false,
            isHazardous: false,
            isEmpty: false,
            isHighCube: false,
            isBreakBulk: false,
          }],
        },
        hold: {
          cols: 4,
          rows: 4,
          cells: [{ existed: true, isReefer: false, is45Foot: false }, { existed: false, isReefer: true }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false },],
        },
      })
    },
    vesselBayIndex: { type: Number },
    vesselHatchIndex: { type: Number, },
    name: {
      default: '001(002)',
      type: String,
    },
    minDeckTiersNo: { default: 0 },
    minHoldTiersNo: { default: 0 },
  },
  data() {
    return {
      childData: null
    }
  },
  methods: {
    receiveDataFromChild(data) {
      if(data>0)
      this.childData = this.getvoyageContainersList.details.filter((c) =>c.stowageInstructionDetailId == data)[0];  
    else{
      this.childData  = null
    }
    },
  },
  computed: {
    ...mapGetters(['getvoyageContainersList'])
  },
      mounted() { }
})
